import 'reflect-metadata';
import Vue, { CreateElement } from 'vue';
import BaseComponent from '@/mixins/BaseComponent';
// plugins
import '@/plugins/vee-validate';
// entry component
import ForgotPassword from './ForgotPassword.vue';

new Vue({
	mixins: [BaseComponent],
	render(h: CreateElement) {
		return h(ForgotPassword);
	}
}).$mount('#yfc_forgotpwd');
